export const fullLocation = `
id,
title,
locale,
timezone,
currency,
taxExclusive,
taxAmount,
twentyFourHourTime
updatedAt
usesHaze
darkMode
`;
